import { AuraIcon } from '@com-delta-omnichannel/aura';
import { NotificationType } from '../models/notification.interfaces';

export const getNotificationIcon = (type: NotificationType): AuraIcon => {
  const notification = type === 'success' ? 'success' : 'alert';
  return {
    id: type,
    disabled: false,
    width: '18.75px',
    height: '18.75px',
    alt: `${type} icon`,
    src: `/content/dam/delta-applications/ui-kit/assets/svg/alerts/${notification}-icon.svg`
  };
};
